import { useTranslation } from 'react-i18next'

import { E2FAMethod, E2FAMethodTab } from 'src/types'
import { ReturnBackButton } from '../../return-back-button.component'

import { VerificationForm } from '../verification-form.component'
import { SwitchFormWrapper } from './switch-form-wrapper.component'

interface IProps {
  method: E2FAMethod | null
  subTab: E2FAMethodTab
  returnBack: () => void
}

export const SwitchTotp2FA = ({ method, subTab, returnBack }: IProps) => {
  const [t] = useTranslation()

  if (subTab !== E2FAMethodTab.Switch || !method) {
    return null
  }

  return (
    <div>
      <ReturnBackButton returnBack={returnBack} />
      <SwitchFormWrapper>
        <VerificationForm
          buttonText={t('2fa-modal-switch-button.v')}
          text={t('2fa-totp-change-text.v')}
          title={t('2fa-change-title.v')}
        />
      </SwitchFormWrapper>
    </div>
  )
}
